import { Typography } from 'antd'
import { ToolOutlined } from '@ant-design/icons'

interface MaintenanceProps {
  /** バックエンド設定の任意メッセージ。空なら既定文言を表示。 */
  message?: string | null
}

const DEFAULT_MESSAGE =
  'ただいまシステムメンテナンスを実施しております。\n'
  + 'ご不便をおかけしますが、しばらく経ってから再度アクセスしてください。'

/**
 * メンテナンス中の sorry 画面。
 * ログイン前後どちらでも表示できるよう、AuthContext / Navigation などに依存しない単独コンポーネント。
 */
const Maintenance = ({ message }: MaintenanceProps) => {
  const body = message && message.trim() ? message : DEFAULT_MESSAGE

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-6 py-16">
      <div className="bg-white rounded-xl shadow-lg p-10 text-center max-w-xl w-full">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50">
          <ToolOutlined className="text-[40px] text-blue-500" />
        </div>
        <Typography.Title level={3} className="!mb-3">
          メンテナンス中
        </Typography.Title>
        <Typography.Paragraph type="secondary" className="!mb-0 whitespace-pre-wrap leading-7">
          {body}
        </Typography.Paragraph>
      </div>
    </div>
  )
}

export default Maintenance
